import React, { useEffect, useState, useRef } from 'react';
import echo from '../utils/echo';
import { apiGet, apiPost } from '../utils/api';
import "../styles/ChatWidget.css";
import { FaTimes } from "react-icons/fa"; 

export default function ChatWidget({ companyId, onClose }) {
  const [messages, setMessages] = useState([]);
  const [text, setText] = useState('');
  const endRef = useRef();
  useEffect(() => {
    let mounted = true;
    (async () => {
      const res = await apiGet(`/companies/${companyId}/messages`);
      const data = await res.json().catch(() => []);
      if (mounted) setMessages(data);
    })();
    const channel = echo.private(`company-chat.${companyId}`);
    channel.listen('MessageSent', e => {
      setMessages(prev => [...prev, e]);
    });
    return () => {
      mounted = false;
      channel.stopListening('MessageSent');
      channel.unsubscribe();
    };
  }, [companyId]);

  useEffect(() => {
    endRef.current?.scrollIntoView({ behavior: 'smooth' });
  }, [messages]);

  const send = async () => {
    if (!text.trim()) return;
    const res = await apiPost(`/companies/${companyId}/messages`, { message: text });
    if (res.ok) {
      const data = await res.json();
      setMessages(prev => [...prev, data]);
      setText('');
    }
  };
  return (
    <div className="chat-widget">
        <div className="chat-header">
        <strong>Chat</strong>
        <button className="close-btn" onClick={onClose}>
            <FaTimes />
        </button>
        </div>
      <div className="chat-messages" style={{ maxHeight: 300, overflowY: 'auto' }}>
        {messages.map(m => (
          <div key={m.id} className={`message ${m.user?.role === 'admin' ? 'admin' : 'customer'}`}>
            <small>{m.user?.name}</small>
            <div>{m.message}</div>
          </div>
        ))}
        <div ref={endRef} />
      </div>
      <div className="chat-input">
        <input value={text} onChange={e => setText(e.target.value)} placeholder="Type a message..." />
        <button onClick={send}>Send</button>
      </div>
    </div>
  );
}